module.exports = __webpack_public_path__ + "img/logo-escape.57786e2.svg";